"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _Footer = _interopRequireDefault(require("../../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../../components/Nav/Header"));
var _lodash = require("lodash");
var _globalDataContext = require("../../lib/globalDataContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

var FinproUserProfileLayout = props => {
  if (!props.route.fields) return null;
  var route = props.route;
  (0, _globalDataContext.setGlobalData)(props);
  var leadFormContent = (0, _lodash.get)(route, 'placeholders.form-content');
  var formRenderingFields = leadFormContent && leadFormContent.length > 0 ? leadFormContent[0] : null;
  var navSettingContent = (0, _lodash.get)(route, 'placeholders.nav-settings');
  var navSettingFields = navSettingContent && navSettingContent.length > 0 ? navSettingContent[0].fields : null;
  if (navSettingFields) {
    route.fields.SiteNavName = (0, _lodash.get)(navSettingFields, 'SiteNavName');
    route.fields.SiteFooterNav = (0, _lodash.get)(navSettingFields, 'SiteFooterNav');
    route.fields.NavSetting = (0, _lodash.get)(navSettingFields, 'NavSetting');
    route.fields.ComplianceNumber = route.templateId === '489ccd12-e1af-47b0-886e-8cdef9963ec1' ? (0, _lodash.get)(route.fields, 'Bio CRN') : (0, _lodash.get)(navSettingFields, 'ComplianceNumber');
  }
  var pageProps = {
    utagSiteName: props.headTagsProps.utagSiteName,
    addUtagLoginCookie: props.headTagsProps.addUtagLoginCookie
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor finpro-profile"
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "main-content-full-body",
    rendering: route,
    params: props.componentProps,
    formParams: formRenderingFields,
    pageprops: pageProps
  })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    fields: route.fields,
    componentParams: props.componentProps,
    params: props.headTagsProps
  }));
};
var _default = exports.default = FinproUserProfileLayout;